import axios from 'axios'
import { config as configuration} from '../config'

const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
const keys = await response.json();

axios.interceptors.request.use(
    async (config) => {
        const bearerToken = sessionStorage.getItem('bearerToken');
        config.baseURL= keys.REACT_APP_BASE_URL;
        if (bearerToken) {
            config.headers.common = {
                Authorization: `Bearer ${bearerToken}`,
                'Ocp-Apim-Subscription-Key': ''
            }
        }
        config.params.version_num = 0
        return config
    },
    (error) => {
        Promise.reject(error)
    }
)
